import React, { Component } from 'react';
import '../../styling/create/create.css';
import Header from '../shared/header.js';
import Footer from '../shared/footer.js';

class Create extends Component {
  render() {
    return (
      <div>
        <Header/>
        <div className="create">
          <div className="container">
            <div className="row">
              <div className="jumbotron">
                <h4>Como cadastrar meu evento?!</h4>
                <hr className="my-4"></hr>
                <p>O sistema é simples. Todos os eventos dos <i>coworkings</i> da rede BeerOrCoffee que forem cadastrados no Lets.events aparecem automaticamente aqui no Eventos Coworking.</p>
                <p>Se você não trabalha em um <i>coworking</i>, mas está organizando um evento em um deles e gostaria de divulgá-lo aqui, também é possível.</p>
                <p>Como estamos em fase de testes, é preciso preencher o seguinte formulário, que entraremos em contato!</p>
                <iframe title="Mautic form" src="https://mautic.forky.com.br/form/4" width="100%" height="600px" frameBorder="0"><p>Your browser does not support iframes.</p></iframe>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Create;



// WEBPACK FOOTER //
// ./src/component/create/create.js